import React from 'react';

const CookieToggle = ({ checked, onChange, disabled, label, description, requiredText }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (!disabled) {
        onChange(!checked);
      }
    }
  };

  return (
    <div className="st-cookie-toggle-wrapper">
      <div className="st-cookie-toggle-label-group">
        <label className="st-cookie-toggle-label">
          {label}
          {disabled && requiredText && <span className="st-cookie-toggle-required">{requiredText}</span>}
        </label>
        {description && (
          <p className="st-cookie-toggle-description">{description}</p>
        )}
      </div>
      
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={label}
        className={`st-cookie-toggle ${checked ? 'st-cookie-toggle-checked' : ''} ${disabled ? 'st-cookie-toggle-disabled' : ''}`}
        onClick={() => !disabled && onChange(!checked)}
        onKeyDown={handleKeyPress}
        disabled={disabled}
      >
        <span className="st-cookie-toggle-track">
          <span className="st-cookie-toggle-thumb" />
        </span>
      </button>
    </div>
  );
};

export default CookieToggle;
